import { PaginationResp } from './../common/interfaces/pagination-resp';
import { environment } from './../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
export class ElementSVC {

   
   protected apiurl = environment.apiurl;
   protected apiurl_admin = environment.apiurl_admin;

    constructor(protected http: HttpClient) {
        this.http = http;
     }
    
    /*getServerDataSource(filter = ''): ServerDataSource {
        // let source = new ServerDataSource(this.http, {endPoint: this.APIURL});
        //source.setFilter([{field: 'title', search: 'acc'}]);
        return this.helper.getServerDataSource(this.apiurl + '?' + filter);
      }*/
    
      esportaExcel(filter = []){
        let f: string[] = [];
        if(filter.length>0){
          filter.forEach(function(v){
             f.push(v.field.replace('$$', '$')+'='+v.search);
          });
        } 
        return this.http.get(this.apiurl+'/excel?'+f.join('&'), { responseType: 'blob'});
      }
    
      deleteElement(id: string | number){
        return this.http.delete(this.apiurl+'/'+id).pipe(catchError(this.handleError));
      }

      getItems(filterobj = {}) : Observable<PaginationResp<any> | any> {
        return this.http.get(this.apiurl, { params: filterobj }).pipe(catchError(this.handleError));
      }

      getElement(id: string | number){
        return this.http.get(this.apiurl+'/'+id).pipe(catchError(this.handleError));
      }

      getElements(filter?: string | undefined) {
        return this.http.get(this.apiurl+ (filter!=undefined ? '?' + filter : '')).pipe(catchError(this.handleError));
      }

      getPlainObject(idelemento: any, url: string[]){
        let urlstr = this.setUrlRequest(idelemento, url);
        return this.http.get(urlstr);
      }
    
      getFile(idelemento: string, idfile: string){
        return this.http.get(this.apiurl+'/'+idelemento+'/files/'+idfile, { responseType: 'blob'});
      }

      delFile(idelemento: string, idfile: string) : any {
        //const options = { responseType: 'blob' };
        return this.http.delete(this.apiurl+'/'+idelemento+'/files/'+idfile);
        /*return true;/*(map(
        (res: Response) => {
            return new Blob([res], {
              type: 'application/pdf'
            });
        }));*/
      }

      getBlob(idelemento: any, urlblob: string[]){
        let urlstr = this.setUrlRequest(idelemento, urlblob);
        return this.http.get(urlstr, { responseType: 'blob'});
      }

      protected setUrlRequest(idelemento: string, url: string[]){
        return this.apiurl+'/' + idelemento + '/' + url.join('/');
      }

      private handleError(error: HttpErrorResponse) {
        
        if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(
            `Backend returned code ${error}, ` +
            `body was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(() => {
          
         return  new Error(
          error.error?.message ? error.error.message : 'Something bad happened; please try again later.');
        });
      };
    
      
    
     
    
      save(elemento: any, id?: string | number | undefined){
        if(id!=undefined){
          return this.http.put(this.apiurl+'/'+id, elemento).pipe(catchError(this.handleError));
        } else {
          return this.http.post(this.apiurl, elemento).pipe(catchError(this.handleError));
        }
      }
}
